// extracted by mini-css-extract-plugin
module.exports = {"snackbar-wrapper":"snackbar_snackbar-wrapper__J0Nyo","snackbar-text":"snackbar_snackbar-text__MI7B1"};